export const paths = {
  home: '/',
  KnowledgeDatabase: '/knowledgedatabase/:tenantId',
  KnowledgeDatabaseFolder: '/knowledgedatabase/:tenantId/folders/:folderId',
  KnowledgeDatabaseSearchResults: '/knowledgedatabase/:tenantId/search',
  KnowledgeDatabaseQuestion: '/knowledgedatabase/:tenantId/question/:questionId',
}

export function buildKnowledgeDatabasePath(tenantId: string) {
  return paths.KnowledgeDatabase.replace(':tenantId', encodeURIComponent(tenantId))
}

export function buildKnowledgeDatabaseFolderPath(tenantId: string, folderId: string) {
  return paths.KnowledgeDatabaseFolder
    .replace(':tenantId', encodeURIComponent(tenantId))
    .replace(':folderId', encodeURIComponent(folderId))
}

export function buildKnowledgeDatabaseSearchResultsPath(tenantId: string, query: string) {
  const path = paths.KnowledgeDatabaseSearchResults.replace(':tenantId', encodeURIComponent(tenantId))
  return `${path}?query=${encodeURIComponent(query)}`
}

export function buildKnowledgeDatabaseQuestionPath(tenantId: string, questionId: string, query?: string) {
  const path = paths.KnowledgeDatabaseQuestion
    .replace(':tenantId', encodeURIComponent(tenantId))
    .replace(':questionId', encodeURIComponent(questionId))
  return query !== undefined && query.length > 0 ? `${path}?query=${encodeURIComponent(query)}` : path
}
